module.exports = __webpack_public_path__ + "static/img/goods01.7f0a841c.jpg";